import React, { Dispatch, SetStateAction } from 'react';
import { Outlet, useOutletContext } from 'react-router-dom';

import { UseOutletContextSale } from '../Sale';
import { User } from '../../../../models/user.model';
import { AppService } from '../../../../models/app.service.model';
import { Company } from '../../../../models/company.model';
import { Settings } from '../../../../models/settings.model';
import { Contact }  from '../../../../models/contact.model';
import { TreasuryAccount } from '../../../../models/treasury.account.model';
import { Service } from '../../../../models/service.model';
import { Product } from '../../../../models/product.model';

export interface QuotePageProps {};

type ContexType = {
  setRoute: Dispatch<SetStateAction<{path: {root: string, branch: string} | null, company: boolean} | null>>,
  userLoggedIn: User | null,
  appServiceForUser: AppService | null,
  companyForUser: Company | null,
  settingsForCompany: Settings | null,
  treasuryAccountsForCompany: TreasuryAccount[] | null,
  contactsForCompany: Contact[] | null,
  servicesForCompany: Service[] | null,
  productsForCompany: Product[] | null,
  loadSettingsForCompany: Function,
  loadContactsForCompany: Function
};

const QuotePage: React.FunctionComponent<QuotePageProps> = props => {
  const {setRoute, userLoggedIn, appServiceForUser, companyForUser, settingsForCompany, treasuryAccountsForCompany, contactsForCompany, servicesForCompany, productsForCompany, loadSettingsForCompany, loadContactsForCompany} = UseOutletContextSale()

  return (
    <Outlet context={{setRoute, userLoggedIn, appServiceForUser, companyForUser, settingsForCompany, treasuryAccountsForCompany, contactsForCompany, servicesForCompany, productsForCompany, loadSettingsForCompany, loadContactsForCompany}}></Outlet>
  );
}

export function UseOutletContextQuote() {
  return useOutletContext<ContexType>()
};

export default QuotePage;
